import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { fetchAccountPlansActivation, setActivePlanId } from 'alelo-logic/actions'

import Header from '../../modules/Header'
import Submenu from '../../elements/Submenu'
import FooterSmall from '../../elements/FooterSmall'
import PageLoader from '../../modules/PageLoader'
import { setLoading } from '../../modules/PageLoader/actions'

import { subnavLinks } from './data.json'

import { RouteWithSubRoutes } from '../../../routes'

class TemplateProfileActivation extends Component {
  async componentDidMount() {
    this.props.setLoading(true)
    await this.props
      .fetchAccountPlansActivation()
      .then(() => this.props.setActivePlanId(this.props.match.params.id))
      .then(() => this.props.setLoading(false))
  }

  shouldComponentUpdate(nextProps) {
    const hasChange =
      // eslint-disable-next-line
      nextProps.accountPlans.activePlanId != nextProps.match.params.id ||
      nextProps.location.pathname !== this.props.location.pathname

    if (hasChange) {
      this.props.setActivePlanId(this.props.match.params.id)
    }
    return hasChange
  }

  componentDidUpdate() {
    this.props.setActivePlanId(this.props.match.params.id)
  }

  render() {
    const { routes, match } = this.props

    const subnavLinksWithPlanId = subnavLinks.map(subnavLink => ({
      ...subnavLink,
      link: subnavLink.link.replace(':id', match.params.id)
    }))

    return (
      <div>
        <div className="empty-template">
          <Header />
          <Submenu navItems={subnavLinksWithPlanId} />
        </div>
        <PageLoader>
          <div>{routes.map(route => <RouteWithSubRoutes key={route.path} {...route} />)}</div>
        </PageLoader>
        <div className="empty-template">
          <FooterSmall />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  account: state.reducer.account,
  accountPlans: state.reducer.accountPlans.plans
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchAccountPlansActivation: () =>
    dispatch(fetchAccountPlansActivation()).then(accountPlans => {
      const { history, match } = ownProps
      if (
        accountPlans &&
        (match.params.id === '' || match.params.id === 'identificadores-parceiros')
      ) {
        const firstPlanId = accountPlans && accountPlans[0] && accountPlans[0].id
        history.push(`/minha-veloe/${firstPlanId}/resumo`)
      }
    }),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  setActivePlanId: planId => dispatch(setActivePlanId(planId))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateProfileActivation))



// WEBPACK FOOTER //
// ./src/app/templates/TemplateProfileActivation/index.js